module.exports = __webpack_public_path__ + "files/CLEANHANDPROX.ffed8fb8c416333a4f65f6d4edb001f0.zip";